export default [{
  selector: '*',
  style: {
    margin: 0,
    padding: 0
  }
}, {
  selector: 'html',
  style: {
    WebkitTextSizeAdjust: '100%'
  }
}];